import { apiRequest } from '@/shared/api';

import type {
  CurrentDraws,
  MonthlyDraw,
  SeasonFinalDraw,
} from '../model/types';

/**
 * `null` — ни один Месячный цикл ещё не завершился: розыгрыш
 * материализуется при подведении итогов, а не заранее.
 */
export function fetchMonthlyDraw(): Promise<MonthlyDraw | null> {
  return apiRequest<MonthlyDraw | null>('/draws/monthly');
}

/**
 * Что разыгрывается сейчас: призы текущего цикла и сезона ДО жеребьёвки.
 * `null` — активного Месячного цикла нет.
 */
export function fetchCurrentDraws(): Promise<CurrentDraws | null> {
  return apiRequest<CurrentDraws | null>('/draws/current');
}

/** `null` — Финальный розыгрыш ещё не подготовлен (ГДД §11.3). */
export function fetchSeasonFinal(): Promise<SeasonFinalDraw | null> {
  return apiRequest<SeasonFinalDraw | null>('/draws/season-final');
}
